/**
 * Get Document Chat Status Action
 * 
 * Checks if a job has document chat embeddings available.
 * Used to determine if the "Chat with Documents" button should be shown.
 */

import axiosInstance from '../utils/axiosInstance';

export interface DocumentChatStatusResponse {
  jobId: string;
  chatEnabled: boolean;       // Whether embeddings are ready
  embeddingsStatus: 'READY' | 'PROCESSING' | 'EXPIRED' | 'NOT_AVAILABLE';
  expiresAt?: string;         // ISO timestamp when embeddings expire
  isPremiumUser: boolean;     // Whether user has premium access
  message?: string;
}

/**
 * Check if document chat is available for a specific job
 * 
 * @param jobId - The job to check
 * @returns Chat availability status
 */
export async function getDocumentChatStatus(
  jobId: string
): Promise<DocumentChatStatusResponse> {
  console.log('[Action] getDocumentChatStatus called for job:', jobId);

  const response = await axiosInstance.get<DocumentChatStatusResponse>(
    `/jobs/${jobId}/chat/status`
  );

  console.log('[Action] getDocumentChatStatus received response:', {
    jobId: response.data.jobId,
    chatEnabled: response.data.chatEnabled,
    embeddingsStatus: response.data.embeddingsStatus,
    isPremiumUser: response.data.isPremiumUser,
  });

  return response.data;
}

